"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var transformValueToProp = function (value) {
  if (value && typeof value === "object" && typeof value.toJSON === "function") {
    return value.toJSON();
  }

  return value;
};

var _default = transformValueToProp;
exports.default = _default;